import styled from "styled-components";

export const Field = styled.input`
    padding: 8px; 
    border: 1px solid #d4d4d4;
`;
